import { useCallback } from 'react'
import { useAppDispatch } from '@/utils/typeHelpers'
import { useReselector } from '@/utils/sharedHooks'
import {
  selectConversations,
  selectConversationsLoaded,
  selectHasMoreConversations,
} from '@/features/adviser-chat/adviser-chat.selectors'
import { fetchConversations, deleteConversation } from '../adviser-chat.actions'
import { startNewConversation, setActiveView } from '../adviser-chat.slice'

export const useConversations = () => {
  const dispatch = useAppDispatch()
  const conversations = useReselector(selectConversations)
  const loaded = useReselector(selectConversationsLoaded)
  const hasMore = useReselector(selectHasMoreConversations)

  const load = useCallback(() => {
    if (!loaded) dispatch(fetchConversations())
  }, [dispatch, loaded])

  const refresh = useCallback(() => {
    dispatch(fetchConversations())
  }, [dispatch])

  const loadMore = useCallback(() => {
    dispatch(fetchConversations(conversations.length))
  }, [dispatch, conversations.length])

  const remove = useCallback(
    (id: number) => dispatch(deleteConversation(id)),
    [dispatch]
  )

  const startNew = useCallback(() => {
    dispatch(startNewConversation())
  }, [dispatch])

  const showHistory = useCallback(() => {
    dispatch(setActiveView('history'))
  }, [dispatch])

  const hideHistory = useCallback(() => {
    dispatch(setActiveView('chat'))
  }, [dispatch])

  return {
    conversations,
    loaded,
    hasMore,
    load,
    loadMore,
    refresh,
    remove,
    startNew,
    showHistory,
    hideHistory,
  }
}
